<main id="top" class="flex flex-column align-items-center">
  <div
    id="terms-panel"
    class="flex flex-column w-11 lg:w-8 xl:w-6 justify-content-center align-content-center"
  >
    <h1>Custom Plotting Tutorial</h1>
    <p class="text-primary">
      This <strong>Jupiter Notebook</strong> tutorial demonstrates how to create
      and customized map plots from the <strong>NetCDF-files </strong>
      produced during the QA4SM validation. The customization is done by varying
      different kinds of input parameters like title, label, font sizes,
      colormaps, value ranges, spatial extent and plot size. The customization
      can be executed for all relevant variables in the netcdf dataset as long
      as they are valid (Section 2).
    </p>
    <!-- Create & download -->
    <div>
      <p>
        <button class="btn" type="button" (click)="DownloadJupiterNotebook()">
          Download Jupiter Notebook
        </button>
      </p>
    </div>
    <p class="text-primary">
      The plotting uses a <strong>CustomPlotObject</strong> which contains the
      two functions plot_map and display_metrics_and_datasets. The
      display_metrics_and_datasets function are used to display the available
      metrics and datasets in the NetCDF file whereas the function plot_map
      provides the necessary plotting functionality.
    </p>
    <p class="text-primary">
      The routine for the plot_map function looks like this:
    </p>
    <pre><code>"plot_obj.plot_map(metric = 'R',
      output_path = r"C:\Users\agruber\Desktop\tmp\custom_plots\plot_tests",
    dataset_list = ['ERA5_LAND', 'C3S_combined'])"</code></pre>

    <p class="text-primary">
      The inputs "metric", "output_path", and "dataset_list" are mandatory, all
      other plot parameters are optional, if omitted, a standardized plot like
      on the QA4SM website will be created. In order to customize the plot the
      following parameters can be modified:
    </p>

    <ul>
      <li>colormap: Changes colormap of plot</li>
      <li>
        value_range: Changes the displayed value range of the variable of
        interest
      </li>
      <li>extent: Specifies the spatial extent of the plot</li>
      <li>title: Specifies the plot title</li>
      <li>title_fontsize: Specifies the fontsize of the title</li>
      <li>colorbar_label: Specifies the colorbar label title</li>
      <li>
        colorbar_ticks_fontsize: Changes the fontsize of the color bar value
        ticks
      </li>
      <li>
        xy_ticks_fontsize: Changes the fontsize of the lat lon labels of the map
        plot
      </li>
      <li>plotsize: Changes the overall figure size</li>
    </ul>
    <p class="text-primary">
      Now follows a step by step demonstration of different custom plots.
    </p>

    @for (step of steps; track step; let i = $index) {
      <section>
        <h3>{{ step.title }}:</h3>
        <p class="text-primary">{{ step.description }}</p>
        <div class="nb-cell nb-code">
          <div class="nb-gutter">
            <span class="io">In</span>&nbsp;[<span class="count">{{
              i + 1
            }}</span
            >]:
          </div>
          <div class="nb-content">
            <!-- One-line code -->
            <pre><code>{{ step.code }}</code></pre>
            <!-- Hidden source -->
            <textarea
              id="copy-code{{ i }}"
              class="sr-only"
              aria-hidden="true"
              >{{ step.code }}</textarea
            >
          </div>
          <div class="nb-button">
            <!-- Copy button -->
            <a
              class="copy-btn"
              (click)="copy('copy-code' + i)"
              aria-label="Copy code"
            >
              <i class="pi pi-fw pi-copy"></i> Copy
            </a>
          </div>
        </div>
        @if (step.image) {
          <figure>
            <img
              [src]="step.image"
              alt="{{ step.title }} figure"
              style="max-width: 100%; height: auto"
            />
          </figure>
        }
      </section>
    }
  </div>
</main>
